<template>
    <div class="intent">
        <div style="height:20px"></div>
        <div  v-if="orders.length > 0" class="order-list">
            <div class="intent-block order-block" v-for="(item, index) in orders" :key="item.id" @click="openDetail(index)">
                <div class="order-main">
                    <div class="station-info">{{item.station.name}}</div>
                    <div class="order-info">
                        <div class="time">支付时间：{{item.order.createTime.substring(0,16)}}</div>
                        <div class="fee">费用：¥{{item.order.realPrice}}元</div>
                        <div v-if="item.order.payStatus==3" style="font-size:12px;font-style:italic;color:#aaa">退款异常，请联系客服人员处理</div>
                    </div>

                </div>
                <div class="order-status">
                        <span v-if="item.order.payStatus==0" style="color:greed;">待支付</span>
                        <span v-if="item.order.payStatus==1" style="color:greed;">待支付</span>
                        <span v-if="item.order.payStatus==2" style="color:blue;">报名成功</span>
                        <span v-if="item.order.payStatus==3" style="color:red;">已退款</span>
                        <span v-if="item.order.payStatus==4" style="color:greed;">待确认</span>
                        <span v-if="item.order.payStatus==5" style="color:red;">退款中</span>
                        <span v-if="item.order.payStatus==6" style="color:red;">退款异常</span>
                        <span v-if="item.order.payStatus==7" style="color:red;">退款关闭</span>
                        <img src="@/../static/icon_right.png"/>
                    </div>
            </div>
        </div>
        <div v-else class="no-data">
            您还没有报名
        </div>
    </div>
</template>

<script>
import { MessageBox, Toast } from "mint-ui"
import wx from "weixin-js-sdk"
export default {
    //获取openId
    data(){
        return {
            code: '',
            openId: '',
            wechatReady: false,
            orders:[]
        }
    },
    mounted(){
        this.openId = localStorage.getItem("openId");
        this.getWechatSign();
        wx.ready(function(){

        });
        wx.error(function(res){
            MessageBox.alert("微信支付初始化失败");
        });
    },
    methods:{
        getWechatSign:function(){
            const self = this;
            let url = location.href;
            console.log("url" + url);
            let encodeUrl = encodeURIComponent(url);
            this.$http.get("/bicycle/inter/getWechatSign?url="+encodeUrl).then(function(res){
                if(res.data.status != 200){
                     MessageBox.alert(res.data.errorMsg);
                }else{
                    let e = res.data.data;

                    if(self.$route.query.code){
                        self.code = self.$route.query.code;
                        wx.config({
                            debug: false, // 关闭调试模式
                            appId: e.appId, // 必填，公众号的唯一标识
                            timestamp: e.timestamp, // 必填，生成签名的时间戳
                            nonceStr: e.nonceStr, // 必填，生成签名的随机串
                            signature: e.signature,// 必填，签名
                            jsApiList: [
                                'chooseWXPay'
                            ]// 必填
                        });
                        //获取openId
                        if(!self.openId){
                            self.getOpenId();
                        }else{
                            self.getOrders();
                            self.wechatReady = true;
                        }

                        // url = location.origin + location.pathname;
                        // console.log("url" + url);
                        // history.pushState({}, document.title, url);
                    }else{
                        let currentUrl = location.href;
                        let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +e.appId+ "&redirect_uri="+ encodeURIComponent(currentUrl)+"&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
                        window.location.href = redirectUrl;
                    }
                }
            }).catch(function(error){
                console.log(error)
            });
        },
         getOpenId:function(){
            const self = this;
            self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                    }else{
                        self.openId = res.data.data;
                        localStorage.setItem("openId", self.openId);
                        self.getOrders();

                        self.wechatReady = true;
                    }
                }).catch(function(error){
                    console.log(error)
                });
        },
        getOrders:function(){
            const self = this;
            self.$http.get("/bicycle/inter/intentList?openId=" + self.openId).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                    }else{
                        self.orders = res.data.data;
                    }
                }).catch(function(error){
                    console.log(error)
                });
        },
        openDetail:function(index){
            let item = this.orders[index];
            let url = location.protocol + "//" + location.hostname + "/abc/intented?orderId="+item.order.orderId;
            // this.$router.push("/intented?orderId="+ item.order.orderId);
            window.open(url)
        }
    }
}
</script>

<style scoped>
.order-block{
    display: flex;
    align-items: center;
}
.station-info{
    font-size: 22px;
}
.order-main{
    width: 70%;
}
.order-status{
    font-size: 16px;
    text-align: right;
    width: 30%;
}
.order-info{
    margin-top: 12px;
    line-height: 20px;
}
.intent-block:active{
    background: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/MobileIntentedList.vue